import axios from 'axios';
import { API_BASE_URI } from 'library/constants/api';
import type { CategoryView } from 'containers/AdminDashboard/uniqueStayTags';

const BASE = `${API_BASE_URI}/admin/unique-stays`;

const authHeaders = () => {
  const token = localStorage.getItem('jwtToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export interface UniqueStayProperty {
  propertyId: number;
  title?: string | null;
  city?: string | null;
  tagIds: number[];
}

/** Admin-only calls: the backend refuses anyone who is not on its admin list. */
const UniqueStayService = {
  getTags: async (): Promise<CategoryView[]> => {
    const res = await axios.get(`${BASE}/tags`, { headers: authHeaders() });
    return res.data?.result ?? [];
  },

  getProperty: async (propertyId: number | string): Promise<UniqueStayProperty | null> => {
    const res = await axios.get(`${BASE}/properties/${propertyId}`, { headers: authHeaders() });
    return res.data?.result ?? null;
  },

  setTags: async (propertyId: number | string, tagIds: number[]): Promise<number[]> => {
    const res = await axios.put(`${BASE}/properties/${propertyId}/tags`, { tagIds }, { headers: authHeaders() });
    return res.data?.result ?? [];
  },
};

export default UniqueStayService;
